import React, { useState, useEffect, useCallback } from 'react';
import { Button, Dropdown, Toggle } from '../../../../../common/ui';
import styles from './styles.module.css';

const AddPaymentMethodModal = ({
  open,
  setOpen,
  onSave,
  editingCompanyPaymentMethod = null,
  paymentMethods = [],
}) => {
  const [formData, setFormData] = useState({
    paymentMethodId: '',
    isNeedToManageAccount: false,
  });

  useEffect(() => {
    if (editingCompanyPaymentMethod) {
      setFormData({
        paymentMethodId: editingCompanyPaymentMethod.paymentMethodId || '',
        isNeedToManageAccount: Boolean(editingCompanyPaymentMethod.isNeedToManageAccount),
      });
    } else {
      setFormData({
        paymentMethodId: '',
        isNeedToManageAccount: false,
      });
    }
  }, [editingCompanyPaymentMethod, open]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setFormData({
      paymentMethodId: '',
      isNeedToManageAccount: false,
    });
  }, [setOpen]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, handleClose]);

  const handleSave = () => {
    if (!formData.paymentMethodId) {
      return;
    }
    onSave({
      paymentMethodId: formData.paymentMethodId,
      isNeedToManageAccount: formData.isNeedToManageAccount,
    });
    setOpen(false);
  };

  const handleToggleChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handlePanelClick = (e) => {
    e.stopPropagation();
  };

  const paymentOptions = (paymentMethods || []).map((option) => ({
    value: option.id,
    label: option.name,
  }));

  const title = editingCompanyPaymentMethod
    ? 'Update Payment Method'
    : 'Add Payment Method';

  if (!open) return null;

  return (
    <div className={styles.root} role="dialog" aria-modal="true" aria-label={title}>
      <div
        className={styles.overlay}
        onClick={handleClose}
        aria-hidden="true"
      />
      <div className={styles.panel} onClick={handlePanelClick}>
        <div className={styles.upperDiv}>
          <div className={styles.titleDiv}>
            <h2 className={styles.modalTitle}>{title}</h2>
          </div>
          <div className={styles.modalContent}>
            <div className={styles.formRow}>
              <div className={styles.textInputContainer}>
                <label htmlFor="payment-method" className={styles.textInputLabel}>
                  Payment Method
                </label>
                <Dropdown
                  id="payment-method"
                  value={formData.paymentMethodId}
                  onChange={(value) =>
                    setFormData((prev) => ({ ...prev, paymentMethodId: value }))
                  }
                  options={paymentOptions}
                  placeholder="Select payment method"
                  disabled={!!editingCompanyPaymentMethod}
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <Toggle
                checked={formData.isNeedToManageAccount}
                onChange={handleToggleChange}
                name="isNeedToManageAccount"
                label="Is Need to Manage Account"
                labelPlacement="start"
              />
            </div>
          </div>
        </div>
        <div className={styles.lowerDiv}>
          <Button type="button" onClick={handleSave}>
            Save
          </Button>
          <Button type="button" variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddPaymentMethodModal;
